(function () {
  'use strict';

  var ROOT_SELECTOR = '.template-product';

  function route(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path.replace(/^\//, '');
  }

  function formatDate(date) {
    var locale = 'en-US';
    try {
      return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' }).format(date);
    } catch (error) {
      return String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0');
    }
  }

  function addDays(days) {
    var date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + days);
    return date;
  }

  function updateDeliveryDates(scope) {
    var from = addDays(5);
    var to = addDays(10);
    var dispatch = addDays(1);
    scope.querySelectorAll('[data-iris-window]').forEach(function (element) {
      element.textContent = formatDate(from) + ' – ' + formatDate(to);
    });
    scope.querySelectorAll('[data-iris-ship]').forEach(function (element) {
      element.textContent = formatDate(dispatch);
    });
  }

  function startCountdown(scope) {
    scope.querySelectorAll('[data-iris-clock]:not([data-lv-clock-ready])').forEach(function (clock) {
      clock.dataset.lvClockReady = 'true';
      function tick() {
        var now = new Date();
        var end = new Date(now);
        end.setHours(24, 0, 0, 0);
        var seconds = Math.max(0, Math.floor((end - now) / 1000));
        var hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
        seconds %= 3600;
        var minutes = String(Math.floor(seconds / 60)).padStart(2, '0');
        var remaining = String(seconds % 60).padStart(2, '0');
        clock.textContent = hours + ':' + minutes + ':' + remaining;
      }
      tick();
      clock._lvInterval = window.setInterval(tick, 1000);
    });
  }

  function setQuantity(quantity) {
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = String(quantity);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    }
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency }).format(cents / 100); }
    catch (error) { return (cents / 100).toFixed(2); }
  }

  function variantData(bundle) {
    var section = bundle && bundle.closest('.shopify-section');
    var node = section ? section.querySelector('[data-iris-variants]') : null;
    if (!node) node = document.querySelector('[data-iris-variants]');
    if (!node) return [];
    try { return JSON.parse(node.textContent || '[]'); }
    catch (error) { return []; }
  }

  function selectedOptions(row) {
    return Array.prototype.map.call(row.querySelectorAll('select'), function (select) { return select.value; });
  }

  function findVariant(bundle, options) {
    return variantData(bundle).find(function (variant) {
      return variant.opts && variant.opts.every(function (value, index) { return String(value) === String(options[index] || ''); });
    }) || null;
  }

  function syncPairImage(bundle, row) {
    var variant = findVariant(bundle, selectedOptions(row));
    var image = row.querySelector('img');
    if (variant && variant.img && image) image.src = variant.img;
    return variant;
  }

  function defaultVariantId(scope) {
    var input = (scope || document).querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input && input.value ? Number(input.value) : null;
  }

  function currentVariant(bundle) {
    var id = defaultVariantId(bundle && bundle.closest('.shopify-section'));
    return variantData(bundle).find(function (variant) { return Number(variant.id) === Number(id); }) || variantData(bundle)[0] || null;
  }

  function selectedTier(bundle) {
    if (!bundle) return null;
    var active = bundle.querySelector('[data-qty].is-on');
    if (active) return active;
    var checked = bundle.querySelector('[data-qty] input:checked');
    return checked ? checked.closest('[data-qty]') : null;
  }

  function tierRows(tier) {
    return tier ? Array.prototype.slice.call(tier.querySelectorAll('[data-livorno-bundle-unit]')) : [];
  }

  function selectedTierQuantity(bundle) {
    var tier = selectedTier(bundle);
    return tier ? (parseInt(tier.getAttribute('data-qty') || '1', 10) || 1) : 1;
  }

  function bogoChoice(tier, role) {
    var row = tier && tier.querySelector('[data-bogo-item="' + role + '"]');
    var select = row && row.querySelector('[data-bogo-variant]');
    var option = select && select.options[select.selectedIndex];
    if (!option || option.disabled || !(Number(option.value) > 0)) return null;
    return { id: Number(option.value), price: Number(option.getAttribute('data-price') || 0) };
  }

  function syncBogoImages(tier) {
    tier.querySelectorAll('[data-bogo-item]').forEach(function (row) {
      var select = row.querySelector('[data-bogo-variant]');
      var option = select && select.options[select.selectedIndex];
      var image = row.querySelector('[data-bogo-image]');
      var url = option && option.getAttribute('data-image');
      if (image && url) image.src = url;
    });
  }

  function selectedTierPrice(bundle) {
    var tier = selectedTier(bundle);
    if (!tier) return 0;
    var quantity = selectedTierQuantity(bundle);
    var discount = parseFloat(tier.getAttribute('data-discount') || '0') || 0;
    var rows = tierRows(tier);
    var base = 0;
    if (rows.length) {
      rows.forEach(function (row) {
        var variant = findVariant(bundle, selectedOptions(row));
        if (variant) base += Number(variant.price || 0);
      });
    } else {
      var variant = currentVariant(bundle);
      base = Number((variant && variant.price) || 0) * quantity;
    }
    return { base: base, final: Math.round(base * Math.max(0, 100 - discount) / 100), discount: discount };
  }

  function updateTierPrice(bundle, tier) {
    if (tier.getAttribute('data-bogo') === 'true') {
      var paid = bogoChoice(tier, 'paid');
      var gift = bogoChoice(tier, 'gift');
      var priceNode = tier.querySelector('[data-livorno-tier-price]');
      var compareNode = tier.querySelector('[data-livorno-tier-compare]');
      if (paid && gift) {
        var total = paid.price + gift.price;
        // Native Shopify Buy X Get Y discounts the lower-priced item when
        // qualifying and discounted items belong to the same product.
        var payable = tier.dataset.bogoMode === 'same' ? Math.max(paid.price, gift.price) : paid.price;
        if (priceNode) priceNode.innerHTML = formatMoney(payable);
        if (compareNode) compareNode.innerHTML = formatMoney(total);
      }
      syncBogoImages(tier);
      return;
    }
    var quantity = parseInt(tier.getAttribute('data-qty') || '1', 10) || 1;
    var discount = parseFloat(tier.getAttribute('data-discount') || '0') || 0;
    var rows = tierRows(tier);
    var base = 0;
    if (rows.length) {
      rows.forEach(function (row) {
        var variant = findVariant(bundle, selectedOptions(row));
        if (variant) base += Number(variant.price || 0);
      });
    } else {
      var variant = currentVariant(bundle);
      base = Number((variant && variant.price) || 0) * quantity;
    }
    var finalPrice = Math.round(base * Math.max(0, 100 - discount) / 100);
    var price = tier.querySelector('[data-livorno-tier-price]');
    var compare = tier.querySelector('[data-livorno-tier-compare]');
    if (price) price.innerHTML = formatMoney(finalPrice);
    if (compare) compare.innerHTML = formatMoney(base);
  }

  function updateAllTierPrices(bundle) {
    if (!bundle) return;
    bundle.querySelectorAll('[data-qty]').forEach(function (tier) { updateTierPrice(bundle, tier); });
  }

  function updateOrderBumpsEligibility(scope, quantity) {
    (scope || document).querySelectorAll('[data-livorno-order-bump]').forEach(function (bump) {
      var trigger = parseInt(bump.getAttribute('data-trigger-quantity') || '1', 10) || 1;
      var eligible = quantity >= trigger;
      bump.classList.toggle('is-eligible', eligible);
      bump.classList.toggle('is-ineligible', !eligible);
      var checkbox = bump.querySelector('[data-livorno-bump-toggle]');
      if (checkbox) {
        checkbox.disabled = !eligible;
        if (!eligible) checkbox.checked = false;
      }
      bump.querySelectorAll('select').forEach(function (select) { select.disabled = !eligible; });
      var status = bump.querySelector('[data-livorno-bump-status]');
      if (status && bump.dataset.autoGift === 'true') status.hidden = !eligible;
    });
  }

  function applyBundleChoice(bundle, offer) {
    if (!bundle || !offer) return;
    bundle.querySelectorAll('[data-qty]').forEach(function (item) {
      var active = item === offer;
      item.classList.toggle('is-on', active);
      var variants = item.querySelector('[data-livorno-tier-variants]');
      if (variants) variants.hidden = !active;
    });
    var quantity = parseInt(offer.getAttribute('data-qty') || '1', 10) || 1;
    setQuantity(quantity);
    var radio = offer.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;
    updateAllTierPrices(bundle);
    updateOrderBumpsEligibility(bundle.closest('.shopify-section') || document, quantity);
    document.dispatchEvent(new CustomEvent('livorno:bundle-tier-selected', {
      bubbles: true,
      detail: {
        quantity: quantity,
        discountPercent: parseFloat(offer.getAttribute('data-discount') || '0') || 0,
        tierId: offer.getAttribute('data-tier-id') || ''
      }
    }));
  }

  function initialiseBundle(scope) {
    scope.querySelectorAll('[data-livorno-bundle]:not([data-lv-ready])').forEach(function (bundle) {
      bundle.dataset.lvReady = 'true';
      var defaultQuantity = parseInt(bundle.getAttribute('data-default-quantity') || '2', 10) || 2;
      var selected = bundle.querySelector('[data-qty].is-on') || bundle.querySelector('[data-qty="' + defaultQuantity + '"]') || bundle.querySelector('[data-qty]');
      if (selected) applyBundleChoice(bundle, selected);
      bundle.querySelectorAll('[data-livorno-bundle-unit]').forEach(function (row) { syncPairImage(bundle, row); });
      updateAllTierPrices(bundle);
    });
    var bundle = scope.querySelector('[data-livorno-bundle]') || document.querySelector('[data-livorno-bundle]');
    updateOrderBumpsEligibility(scope, bundle ? selectedTierQuantity(bundle) : 1);
  }

  function bundleItems(bundle) {
    var tier = selectedTier(bundle);
    if (tier && tier.getAttribute('data-bogo') === 'true') {
      if (tier.getAttribute('data-bogo-ready') !== 'true') return [];
      var paid = bogoChoice(tier, 'paid');
      var gift = bogoChoice(tier, 'gift');
      if (!paid || !gift) return [];
      if (paid.id === gift.id) return [{ id: paid.id, quantity: 2 }];
      return [{ id: paid.id, quantity: 1 }, { id: gift.id, quantity: 1 }];
    }
    var quantity = selectedTierQuantity(bundle);
    var rows = tierRows(tier);
    if (rows.length) {
      var items = [];
      rows.forEach(function (row) {
        var variant = findVariant(bundle, selectedOptions(row));
        if (variant && variant.available !== false) items.push({ id: Number(variant.id), quantity: 1 });
      });
      if (items.length === quantity) return items;
    }
    var id = defaultVariantId(bundle.closest('.shopify-section'));
    return id ? [{ id: id, quantity: quantity }] : [];
  }

  function bumpVariantId(bump) {
    var control = bump.querySelector('[data-livorno-bump-variant]');
    return control && control.value ? Number(control.value) : null;
  }

  function includedBumps(scope, bundleQuantity) {
    var result = [];
    (scope || document).querySelectorAll('[data-livorno-order-bump]').forEach(function (bump) {
      var trigger = parseInt(bump.getAttribute('data-trigger-quantity') || '1', 10) || 1;
      if (bundleQuantity < trigger) return;
      var autoGift = bump.dataset.autoGift === 'true';
      var checkbox = bump.querySelector('[data-livorno-bump-toggle]');
      if (!autoGift && !(checkbox && checkbox.checked)) return;
      var id = bumpVariantId(bump);
      if (!id) return;
      result.push({
        id: id,
        quantity: parseInt(bump.getAttribute('data-quantity') || '1', 10) || 1,
        autoGift: autoGift,
        triggerQuantity: trigger,
        properties: { '_Livorno offer': autoGift ? 'Gift' : 'Order bump' },
        discountCode: (bump.getAttribute('data-discount-code') || '').trim()
      });
    });
    return result;
  }

  function discountCodes(bundle, bumps) {
    var codes = [];
    if (bundle && bundle.getAttribute('data-apply-codes') === 'true') {
      var tier = selectedTier(bundle);
      var tierCode = tier ? (tier.getAttribute('data-discount-code') || '').trim() : '';
      if (tierCode) codes.push(tierCode);
      bumps.forEach(function (item) { if (item.discountCode) codes.push(item.discountCode); });
    }
    return codes.filter(function (code, index) { return codes.indexOf(code) === index; });
  }

  // Handle add-to-cart on SUBMIT in the capture phase. The stock theme uses
  // a custom form element; a second click handler races its AJAX submission.
  // This path is restricted to the actual product form, including sticky buttons
  // associated through form="..."; collection quick-add remains native.
  function submitLivornoCart(event) {
    var form = event.target;
    if (!document.querySelector(ROOT_SELECTOR) || !form || !form.matches ||
        !form.matches('form[is="product-form"], form[data-type="add-to-cart-form"]')) return;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;

    // Shopify's native handler is attached directly to the form.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.livornoSubmitting === 'true') return;

    var submitter = event.submitter || form.querySelector('button[name="add"]');
    if (submitter && (submitter.disabled || submitter.getAttribute('aria-disabled') === 'true')) return;
    var section = form.closest('.shopify-section') || document;
    var bundle = section.querySelector('[data-livorno-bundle]');
    var formData = new FormData(form);
    var variantInput = form.querySelector('[name="id"]');
    var primaryId = Number(formData.get('id') || (variantInput && variantInput.value) || 0);
    var quantity = Math.max(1, Number(formData.get('quantity') || 1) || 1);
    var items = [];
    var bumps = [];
    var codes = [];
    var bogoInvalid = false;

    if (bundle) {
      quantity = selectedTierQuantity(bundle);
      // Resolve selected product/size independently for each bundle unit.
      // Use the main selected variant only if the bundle has no valid unit rows.
      items = bundleItems(bundle);
      var activeTier = selectedTier(bundle);
      bogoInvalid = !!(activeTier && activeTier.dataset.bogo === 'true' && !items.length);
      bumps = bogoInvalid ? [] : includedBumps(section, quantity);
      var parentProductId = Number(bundle.getAttribute('data-product-id') || '0');
      bumps.forEach(function (item) {
        var properties = Object.assign({}, item.properties || {});
        if (item.autoGift) {
          properties['_Livorno auto gift'] = 'true';
          properties['_Livorno trigger quantity'] = String(item.triggerQuantity || 1);
          if (parentProductId) properties['_Livorno parent product'] = String(parentProductId);
        }
        items.push({ id: item.id, quantity: item.quantity, properties: properties });
      });
      codes = discountCodes(bundle, bumps);
    }

    // A valid variant ID is mandatory. Never send id: 0 / undefined to Shopify.
    var bogoSelected = bundle && selectedTier(bundle) && selectedTier(bundle).dataset.bogo === 'true';
    if (!items.length && primaryId > 0 && !bogoSelected) items.push({ id: primaryId, quantity: quantity });
    if (items.length && primaryId > 0) {
      // Preserve line-item properties (personalisation etc.) from the product form.
      var properties = {};
      formData.forEach(function (value, key) {
        var match = /^properties\[(.+)\]$/.exec(key);
        if (match) properties[match[1]] = String(value);
      });
      if (Object.keys(properties).length) {
        items[0].properties = Object.assign({}, items[0].properties || {}, properties);
      }
      var sellingPlan = formData.get('selling_plan');
      if (sellingPlan) items[0].selling_plan = Number(sellingPlan);
    }

    var errorElement = form.querySelector('.product-form__error-message') ||
      section.querySelector('.product-form__error-message');
    if (errorElement) { errorElement.hidden = true; errorElement.textContent = ''; }
    if (bogoInvalid || !items.length || items.some(function (item) { return !(Number(item.id) > 0 && Number(item.quantity) > 0); })) {
      if (errorElement) { errorElement.textContent = bogoSelected ? 'Please configure the BOGO discount and choose two available items.' : 'Please choose an available size before adding to your basket.'; errorElement.hidden = false; }
      return;
    }

    form.dataset.livornoSubmitting = 'true';
    if (submitter) submitter.setAttribute('aria-busy', 'true');

    fetch(route('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(async function (response) {
        var result = await response.json().catch(function () { return {}; });
        if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'Unable to add product');
        return result;
      })
      .then(async function () {
        // Open after Shopify confirms the item was added, without waiting
        // for discount/cart read/render requests. The normal refresh follows.
        var earlyDrawer = document.querySelector('cart-drawer');
        if (earlyDrawer && typeof earlyDrawer.show === 'function') {
          try { if (!earlyDrawer.open) earlyDrawer.show(); } catch (_) { /* The refresh path still opens it. */ }
        }
        // Discount errors must not hide a successful cart add.
        if (codes.length) {
          try {
            await fetch(route('cart/update.js'), {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ discount: codes.join(',') })
            });
          } catch (_) { /* cart item has already been added */ }
        }
        return fetch(route('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      })
      .then(async function (response) {
        if (!response.ok) throw new Error('Cart was updated but could not be read');
        var cart = await response.json();
        if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            source: 'livorno-product', cart: cart, productVariantId: primaryId
          });
        }
        document.dispatchEvent(new CustomEvent('livorno:offer-added', {
          bubbles: true, detail: { bundleQuantity: quantity, orderBumpCount: bumps.length }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        // Fallback when the cart-drawer was not rendered by Shopify.
        if (!document.querySelector('cart-drawer')) window.location.href = route('cart');
      })
      .catch(function (error) {
        console.error('Livorno basket submission:', error);
        if (errorElement) {
          errorElement.textContent = error.message || 'Unable to add this item. Please try again.';
          errorElement.hidden = false;
        }
      })
      .finally(function () {
        delete form.dataset.livornoSubmitting;
        if (submitter) submitter.removeAttribute('aria-busy');
      });
  }

  function wireThumbnails(scope) {
    var thumbnails = scope.querySelectorAll('.product__thumbnail, media-dots .product__thumbnail, media-dots button');
    thumbnails.forEach(function (thumbnail, index) {
      if (thumbnail.dataset.lvThumbReady === 'true') return;
      thumbnail.dataset.lvThumbReady = 'true';
      thumbnail.addEventListener('click', function () {
        var slides = document.querySelectorAll('.product__media-list .product__media, slider-element .product__media');
        var slide = slides[index];
        if (!slide) return;
        var list = slide.parentElement;
        if (list && list.scrollWidth > list.clientWidth) {
          list.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      });
    });
  }

  function initialiseQuotes(scope) {
    scope.querySelectorAll('[data-iris-quotes]:not([data-lv-ready])').forEach(function (root) {
      root.dataset.lvReady = 'true';
      var slides = Array.prototype.slice.call(root.querySelectorAll('.roma-iris-quote__slide'));
      var index = 0;
      function show() {
        slides.forEach(function (slide, slideIndex) { slide.hidden = slideIndex !== index; });
      }
      var previous = root.querySelector('[data-q-prev]');
      var next = root.querySelector('[data-q-next]');
      if (previous) previous.addEventListener('click', function () { index = (index + slides.length - 1) % slides.length; show(); });
      if (next) next.addEventListener('click', function () { index = (index + 1) % slides.length; show(); });
      show();
    });
  }

  function initialiseSizeGuide(scope) {
    scope.querySelectorAll('[data-iris-chart]:not([data-lv-ready])').forEach(function (button) {
      button.dataset.lvReady = 'true';
      var section = button.closest('.shopify-section') || document;
      var modal = section.querySelector('[data-iris-chart-modal]') || document.querySelector('[data-iris-chart-modal]');
      if (!modal) return;
      button.addEventListener('click', function () { modal.hidden = false; });
      var close = modal.querySelector('[data-iris-chart-close]');
      if (close && close.dataset.lvReady !== 'true') {
        close.dataset.lvReady = 'true';
        close.addEventListener('click', function () { modal.hidden = true; });
      }
      if (modal.dataset.lvReady !== 'true') {
        modal.dataset.lvReady = 'true';
        modal.addEventListener('click', function (event) { if (event.target === modal) modal.hidden = true; });
        modal.addEventListener('keydown', function (event) { if (event.key === 'Escape') modal.hidden = true; });
      }
    });
  }

  function normaliseLabels(scope) {
    scope.querySelectorAll('legend, label, p, span, .variant-picker__label, .product-form__option-info').forEach(function (element) {
      if (element.children.length) return;
      var text = element.textContent || '';
      if (/Shoe size/i.test(text)) element.textContent = text.replace(/Shoe size/gi, 'Size');
      if (/^Save\s+\d+%/i.test(text.trim())) element.textContent = text.trim().replace(/^Save\s+/i, '').replace('%', '% OFF');
    });
    scope.querySelectorAll('button[name="add"]').forEach(function (button) {
      var label = button.querySelector('.btn-text span, .btn-text') || button;
      var text = (label.textContent || '').trim();
      if (/add to cart|buy it now/i.test(text)) label.textContent = 'Add to basket';
    });
  }

  function initialise(scope) {
    if (!document.querySelector(ROOT_SELECTOR)) return;
    updateDeliveryDates(scope);
    startCountdown(scope);
    initialiseBundle(scope);
    wireThumbnails(scope);
    initialiseQuotes(scope);
    initialiseSizeGuide(scope);
    normaliseLabels(scope);
  }

  document.addEventListener('click', function (event) {
    var offer = event.target.closest('[data-livorno-bundle] [data-qty]');
    if (offer) applyBundleChoice(offer.closest('[data-livorno-bundle]'), offer);
  });

  document.addEventListener('change', function (event) {
    var bumpToggle = event.target.closest('[data-livorno-bump-toggle]');
    if (bumpToggle) {
      var bump = bumpToggle.closest('[data-livorno-order-bump]');
      document.dispatchEvent(new CustomEvent('livorno:order-bump-selected', {
        bubbles: true,
        detail: { selected: bumpToggle.checked, mode: bump ? bump.getAttribute('data-mode') : 'optional' }
      }));
      return;
    }
    var select = event.target.closest('[data-livorno-tier-variants] .roma-iris-pair select');
    if (!select) return;
    var row = select.closest('.roma-iris-pair');
    var bundle = select.closest('[data-livorno-bundle]');
    if (row && bundle) { syncPairImage(bundle, row); updateAllTierPrices(bundle); }
  });

  document.addEventListener('change', function (event) {
    var bogoSelect = event.target.closest('[data-bogo-variant]');
    if (!bogoSelect) return;
    var bundle = bogoSelect.closest('[data-livorno-bundle]');
    if (bundle) updateAllTierPrices(bundle);
  });

  document.addEventListener('variant:change', function (event) {
    var section = event.target.closest ? event.target.closest('.shopify-section') : null;
    var bundle = (section || document).querySelector('[data-livorno-bundle]');
    if (bundle) { updateAllTierPrices(bundle); bundle.querySelectorAll('[data-livorno-bundle-unit]').forEach(function (row) { syncPairImage(bundle, row); }); }
  });

  document.addEventListener('submit', submitLivornoCart, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  } else {
    initialise(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-iris-clock]').forEach(function (clock) {
      if (clock._lvInterval) window.clearInterval(clock._lvInterval);
    });
  });
})();

// V13.3: editor block selections should focus the rendered merchant-facing block.
document.addEventListener('shopify:block:select', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLElement)) return;
  const hiddenSlide = target.closest('[hidden]');
  if (hiddenSlide && hiddenSlide.classList.contains('roma-iris-quote__slide')) {
    hiddenSlide.parentElement?.querySelectorAll('.roma-iris-quote__slide').forEach((slide) => { slide.hidden = slide !== hiddenSlide; });
  }
  requestAnimationFrame(() => target.scrollIntoView({ block: 'center', behavior: 'smooth' }));
});
